import React from "react";
import {encodeURI} from "../../utils/gcsUtils";


export function getGcsLink(checkpointUsed) {
    const link = `https://console.cloud.google.com/storage/browser/${encodeURI(checkpointUsed.replace("gs://", ""), false)}`;
    let text = checkpointUsed.substring(checkpointUsed.indexOf('p_run_id=') + 9)
    text = text.includes('/') ? text.substring(0, text.indexOf('/')) : text

    return <a target='_blank'
              rel="noopener noreferrer"
              href={link}>
        {text}
    </a>;
}
